import {
  Button,
  Card,
  CardContent,
  CardHeader,
  ConnectIcon,
  Dialog,
  DisconnectIcon,
  Divider,
  Skeleton,
  Stack,
  Tag,
  Typography,
} from '@all-manager/design-system-v2';
import { useGoogleDriveCard } from './useGoogleDriveCard';

export default function GoogleDriveCard() {
  const hook = useGoogleDriveCard();

  return (
    <Card>
      <CardHeader
        title="Google Drive"
        subheader="Compte Google Drive sur lequel les fichiers sont sauvegardés."
        action={hook.isLoading ? undefined : (
          <Tag
            variantIcon="state"
            color={hook.config ? 'done' : 'default'}
            label={hook.config ? 'Connecté' : 'Non connecté'}
          />
        )}
      />
      <Divider />
      <CardContent>
        {hook.isLoading ? (
          <Stack spacing={1} aria-busy>
            <Skeleton variant="text" width="45%" />
            <Skeleton variant="text" width="30%" />
          </Stack>
        ) : hook.config ? (
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            justifyContent="space-between"
          >
            <Stack spacing={0.5}>
              {hook.config.google_email ? (
                <Typography variant="body1Emphasis">{hook.config.google_email}</Typography>
              ) : null}
              {hook.config.root_folder_name ? (
                <Typography variant="body2">
                  Dossier : {hook.config.root_folder_name}
                </Typography>
              ) : null}
            </Stack>
            {hook.isAdmin ? (
              <Button
                variant="text"
                size="small"
                color="default"
                startIcon={<DisconnectIcon />}
                onClick={hook.handleOpenDisconnect}
                disabled={hook.isDisconnecting}
              >
                Déconnecter
              </Button>
            ) : null}
          </Stack>
        ) : (
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            justifyContent="space-between"
          >
            <Typography variant="body2">
              Aucun compte Google Drive n'est connecté à cet espace.
            </Typography>
            {hook.isAdmin ? (
              <Button
                variant="contained"
                size="small"
                startIcon={<ConnectIcon />}
                onClick={hook.handleConnect}
              >
                Connecter Google Drive
              </Button>
            ) : null}
          </Stack>
        )}
      </CardContent>

      <Dialog
        open={hook.isConfirmingDisconnect}
        onClose={hook.handleCloseDisconnect}
        maxWidth="xs"
        fullWidth
        title="Déconnecter Google Drive ?"
        closeLabel="Fermer"
        actions={{
          primaryAction: {
            label: 'Déconnecter',
            color: 'error',
            onClick: hook.handleConfirmDisconnect,
            loading: hook.isDisconnecting,
          },
          secondaryAction: {
            label: 'Annuler',
            onClick: hook.handleCloseDisconnect,
            disabled: hook.isDisconnecting,
          },
        }}
      >
        <Typography variant="body1">
          L'espace n'aura plus accès à ce compte Google Drive. Les fichiers déjà
          téléversés resteront sur Google Drive mais ne seront plus accessibles
          depuis l'application tant qu'un compte n'est pas reconnecté.
        </Typography>
      </Dialog>
    </Card>
  );
}
